/* Wonderbewbz product page: gallery, booking box, shelf-life card, receipt. */
(function () {
  if (window.__wbProduct) return;
  window.__wbProduct = true;

  function once(el, k) { if (el.dataset[k]) return false; el.dataset[k] = '1'; return true; }
  function money(c) { var v = c / 100; return '$' + (Math.round(v) === v ? v : v.toFixed(2)); }
  function base(v) { return String(v).split(' (')[0].trim(); }
  function litres(v) { var m = String(v).replace(',', '.').match(/(\d+(\.\d+)?)\s*L/i); return m ? parseFloat(m[1]) : 0; }
  function json(el) { try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }

  /* gallery */
  function initGal(root) {
    root.querySelectorAll('[data-wb-gal]').forEach(function (g) {
      if (!once(g, 'wbG')) return;
      var slides = g.querySelectorAll('.wb-gal__slide'), ths = g.querySelectorAll('[data-wb-th]'), cur = 0;
      function set(i) {
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (s, j) { s.classList.toggle('is-on', j === cur); });
        ths.forEach(function (t, j) { t.classList.toggle('is-on', j === cur); });
      }
      ths.forEach(function (t) { t.addEventListener('click', function () { set(+t.dataset.wbTh); }); });
      var x0 = null, main = g.querySelector('.wb-gal__main');
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) set(cur + (dx < 0 ? 1 : -1));
      });
    });
  }

  /* booking box */
  function initBuy(root) {
    root.querySelectorAll('[data-wbp-form]').forEach(function (box) {
      if (!once(box, 'wbB')) return;
      var P = json(box.querySelector('[data-wbp-product]'));
      if (!P) return;
      var T = json(box.querySelector('[data-wbp-trial]'));
      var form = box.querySelector('form'), idIn = box.querySelector('[data-wbp-id]'),
          groups = box.querySelectorAll('[data-wbp-opt]'), total = box.querySelector('[data-wbp-total]'),
          was = box.querySelector('[data-wbp-was]'), tag = box.querySelector('[data-wbp-tag]'),
          line = box.querySelector('[data-wbp-line]'), add = box.querySelector('[data-wbp-add]'),
          addTxt = box.querySelector('[data-wbp-add-txt]'), wa = box.querySelector('[data-wbp-wa]'),
          err = box.querySelector('[data-wbp-err]'), feedsPerL = parseFloat(box.dataset.feeds || '10'),
          trialTag = box.dataset.trialTag || 'Special', section = box.closest('.wb-buy'),
          bar = section && section.querySelector('[data-wbp-bar]'), barPrice = bar && bar.querySelector('[data-wbp-bar-price]');
      var btnLabel = addTxt ? addTxt.textContent : 'Add to cart';

      function selected() {
        return [].map.call(groups, function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; });
      }
      function findVariant(opts) {
        return P.variants.filter(function (v) { return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; }); })[0];
      }
      /* the 1.5L trial special is its own product, match its options by name */
      function trialFor(v) {
        if (!T || !v || !/trial/i.test(v.options[0])) return null;
        var rest = v.options.slice(1).map(base);
        return T.variants.filter(function (t) {
          return t.available && t.options.every(function (o, i) { return base(o) === rest[i]; });
        })[0] || null;
      }
      function priceFor(v) { var t = trialFor(v); return t ? t.price : v.price; }

      /* prices under each volume */
      function paintVolumes(opts) {
        var g = groups[0]; if (!g) return;
        g.querySelectorAll('input').forEach(function (inp) {
          var o = opts.slice(); o[0] = inp.value;
          var v = findVariant(o), card = inp.closest('.wb-choice'),
              pr = card.querySelector('[data-wbp-vprice]'), fd = card.querySelector('[data-wbp-vfeeds]');
          if (!v) return;
          var L = litres(inp.value);
          var cq = v.price === 0 || /contact|quote/i.test(inp.value);
          if (pr) pr.textContent = cq ? 'Custom quote' : money(priceFor(v));
          if (fd) fd.textContent = '';
        });
      }
      function paintAvail(opts) {
        groups.forEach(function (g, gi) {
          g.querySelectorAll('input').forEach(function (inp) {
            var o = opts.slice(); o[gi] = inp.value; var v = findVariant(o);
            inp.disabled = !v || !v.available;
          });
        });
      }

      function update() {
        var opts = selected(), v = findVariant(opts);
        paintVolumes(opts); paintAvail(opts);
        err.hidden = true;
        if (!v) { add.disabled = true; return; }
        var t = trialFor(v), custom = v.price === 0 || /contact|quote/i.test(opts[0]);
        var trialMiss = !t && T && /trial/i.test(opts[0]);
        idIn.value = t ? t.id : v.id;
        box.dataset.cart = t ? 'trial' : 'main';
        var p = t ? t.price : v.price, cmp = t ? (t.compare_at_price || v.price) : v.compare_at_price;
        total.textContent = custom ? 'Custom' : money(p);
        was.textContent = !custom && cmp && cmp > p ? money(cmp) : '';
        tag.hidden = !t; tag.textContent = t ? trialTag : '';
        var L = litres(opts[0]), bits = [];
        if (custom) bits.push('For more than 12L, message us and we will put together a custom quote.');
        else {
          bits.push('Pickup, freeze-drying, quality checks and delivery included.');
          if (trialMiss) bits.push('The trial special price is for Wednesday, Saturday or drop-off.');
        }
        line.textContent = bits.join(' ');
        add.hidden = custom; wa.hidden = !custom;
        add.disabled = !v.available;
        addTxt.textContent = v.available ? btnLabel + ' · ' + money(p) : 'Fully booked';
        if (barPrice) barPrice.textContent = custom ? 'Custom' : money(p);
        if (window.history.replaceState && !t && /\/products\//.test(location.pathname)) {
          try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) {}
        }
        document.dispatchEvent(new CustomEvent('wbp:change', { detail: { volume: base(opts[0]), litres: L, price: p, custom: custom } }));
      }
      groups.forEach(function (g) { g.addEventListener('change', update); });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!window.fetch) { form.submit(); return; }
        add.disabled = true; addTxt.textContent = 'Adding...';
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +idIn.value, quantity: 1 }] })
        }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () { location.href = root + (box.dataset.after === 'checkout' ? 'checkout' : 'cart'); })
          .catch(function (j) {
            err.textContent = (j && (j.description || j.message)) || 'Something went wrong. Please try again or WhatsApp us.';
            err.hidden = false; add.disabled = false; update();
          });
      });

      /* stash planner on the same page picks the volume here */
      document.addEventListener('click', function (e) {
        var cta = e.target.closest && e.target.closest('[data-wb-cta]');
        if (!cta || !groups[0]) return;
        var tier = document.querySelector('[data-wb-tier]'), name = tier ? tier.textContent.trim() : '';
        var inp = [].filter.call(groups[0].querySelectorAll('input'), function (i) {
          return /\+$/.test(name) ? /contact|custom|>/i.test(i.value) : base(i.value).toLowerCase() === name.toLowerCase() || (name && litres(i.value) === litres(name));
        })[0];
        if (!inp) return;
        e.preventDefault(); inp.checked = true; update();
        box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      if (bar) {
        var on = function () {
          var r = box.getBoundingClientRect();
          bar.classList.toggle('is-show', window.scrollY > 600 && (r.bottom < 0 || r.top > window.innerHeight));
        };
        window.addEventListener('scroll', on, { passive: true }); on();
      }
      /* start on ?size=3L, or the default volume, unless a variant is in the link */
      try {
        var q = new URLSearchParams(location.search), want = q.get('size') || (q.get('variant') ? '' : box.dataset.default);
        if (want && groups[0]) {
          [].some.call(groups[0].querySelectorAll('input'), function (i) {
            if (base(i.value).toLowerCase() === want.toLowerCase() || litres(i.value) === litres(want)) { i.checked = true; return true; }
          });
        }
      } catch (e) {}
      update();
    });
  }

  /* frozen vs freeze-dried card */
  function initLife(root) {
    root.querySelectorAll('[data-wbp-life]').forEach(function (c) {
      if (!once(c, 'wbL')) return;
      var copy = json(c.querySelector('[data-wbp-life-copy]')) || {}, big = c.querySelector('[data-wbp-life-big]'),
          small = c.querySelector('[data-wbp-life-small]'), btns = c.querySelectorAll('[data-wbp-life-btn]'), auto = true;
      function set(k) {
        c.classList.toggle('is-dried', k === 'dried');
        btns.forEach(function (b) { var on = b.dataset.wbpLifeBtn === k; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on); });
        c.querySelectorAll('[data-wbp-life-show]').forEach(function (li) { li.hidden = li.dataset.wbpLifeShow !== k; });
        if (copy[k]) { big.textContent = copy[k].big; small.textContent = copy[k].small; }
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { auto = false; set(b.dataset.wbpLifeBtn); }); });
      /* first time it scrolls into view, show frozen then grow to 3 years */
      if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var ob = new IntersectionObserver(function (es) {
          if (!es[0].isIntersecting) return; ob.disconnect();
          setTimeout(function () { if (auto) set('dried'); }, 1600);
        }, { threshold: 0.6 });
        ob.observe(c);
      }
    });
  }

  /* receipt follows the chosen volume */
  function initReceipt() {
    document.addEventListener('wbp:change', function (e) {
      var d = e.detail;
      document.querySelectorAll('[data-wbp-receipt]').forEach(function (r) {
        var vol = r.querySelector('[data-wbp-r-vol]'), pr = r.querySelector('[data-wbp-r-price]');
        if (vol) vol.textContent = d.custom ? '12L+' : d.volume;
        if (pr) pr.textContent = d.custom ? 'Custom' : money(d.price);
      });
    });
  }


  /* jump links: sit under the store header, highlight where mum is */
  function initJump(root) {
    root.querySelectorAll('[data-wbp-jump]').forEach(function (nav) {
      if (!once(nav, 'wbJ')) return;
      var wrap = nav.closest('.wb-jump-wrap') || nav.parentElement, links = [].slice.call(nav.querySelectorAll('a[href^="#"]'));
      var heads = [].slice.call(document.querySelectorAll('header, .shopify-section-header, sticky-header, .section-header, #shopify-section-header'));
      var tick = false;
      function headerBottom() {
        var b = 0;
        heads.forEach(function (h) {
          var cs = getComputedStyle(h);
          if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
          var r = h.getBoundingClientRect();
          if (r.top <= 1 && r.bottom > b && r.height < 220) b = r.bottom;
        });
        return Math.max(0, Math.round(b));
      }
      function update() {
        tick = false;
        document.documentElement.style.setProperty('--wb-jump-top', headerBottom() + 'px');
        var r = nav.getBoundingClientRect(), top = parseFloat(getComputedStyle(wrap).top) || 0;
        nav.classList.toggle('is-stuck', r.top <= top + 1 && window.scrollY > 50);
        var line = r.bottom + 40, cur = null;
        links.forEach(function (a) {
          var t = document.querySelector(a.getAttribute('href'));
          if (t && t.getBoundingClientRect().top <= line) cur = a;
        });
        links.forEach(function (a) {
          var on = a === cur;
          if (on && !a.classList.contains('is-on')) {
            var row = a.parentElement; row.scrollTo({ left: a.offsetLeft - row.clientWidth / 2 + a.clientWidth / 2, behavior: 'smooth' });
          }
          a.classList.toggle('is-on', on);
        });
      }
      window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function init(root) { root = root || document; initGal(root); initLife(root); initBuy(root); initJump(root); }
  initReceipt();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
